/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2RouteImport } from './routes/(auth)/sign-in-2'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedAppointmentsIndexRouteImport } from './routes/_authenticated/appointments/index'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedPatientsPatientIdRouteImport } from './routes/_authenticated/patients/$patientId'
import { Route as AuthenticatedMedicalAppointmentIdRouteImport } from './routes/_authenticated/medical/$appointmentId'
import { Route as AuthenticatedDoctorsMeRouteImport } from './routes/_authenticated/doctors/me'
import { Route as AuthenticatedDoctorsDoctorIdIndexRouteImport } from './routes/_authenticated/doctors/$doctorId/index'
import { Route as AuthenticatedDoctorsDoctorIdSignatureRouteImport } from './routes/_authenticated/doctors/$doctorId/signature'
import { Route as AuthenticatedDoctorsDoctorIdScheduleRouteImport } from './routes/_authenticated/doctors/$doctorId/schedule'
import { Route as AuthenticatedDoctorsDoctorIdProfileRouteImport } from './routes/_authenticated/doctors/$doctorId/profile'
import { Route as AuthenticatedDoctorsDoctorIdDocumentsRouteImport } from './routes/_authenticated/doctors/$doctorId/documents'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignIn2Route = authSignIn2RouteImport.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAppointmentsIndexRoute =
  AuthenticatedAppointmentsIndexRouteImport.update({
    id: '/appointments/',
    path: '/appointments/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedPatientsPatientIdRoute =
  AuthenticatedPatientsPatientIdRouteImport.update({
    id: '/patients/$patientId',
    path: '/patients/$patientId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMedicalAppointmentIdRoute =
  AuthenticatedMedicalAppointmentIdRouteImport.update({
    id: '/medical/$appointmentId',
    path: '/medical/$appointmentId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDoctorsMeRoute = AuthenticatedDoctorsMeRouteImport.update({
  id: '/doctors/me',
  path: '/doctors/me',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDoctorsDoctorIdIndexRoute =
  AuthenticatedDoctorsDoctorIdIndexRouteImport.update({
    id: '/doctors/$doctorId/',
    path: '/doctors/$doctorId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDoctorsDoctorIdSignatureRoute =
  AuthenticatedDoctorsDoctorIdSignatureRouteImport.update({
    id: '/doctors/$doctorId/signature',
    path: '/doctors/$doctorId/signature',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDoctorsDoctorIdScheduleRoute =
  AuthenticatedDoctorsDoctorIdScheduleRouteImport.update({
    id: '/doctors/$doctorId/schedule',
    path: '/doctors/$doctorId/schedule',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDoctorsDoctorIdProfileRoute =
  AuthenticatedDoctorsDoctorIdProfileRouteImport.update({
    id: '/doctors/$doctorId/profile',
    path: '/doctors/$doctorId/profile',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDoctorsDoctorIdDocumentsRoute =
  AuthenticatedDoctorsDoctorIdDocumentsRouteImport.update({
    id: '/doctors/$doctorId/documents',
    path: '/doctors/$doctorId/documents',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/doctors/me': typeof AuthenticatedDoctorsMeRoute
  '/medical/$appointmentId': typeof AuthenticatedMedicalAppointmentIdRoute
  '/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/appointments': typeof AuthenticatedAppointmentsIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/doctors/$doctorId/documents': typeof AuthenticatedDoctorsDoctorIdDocumentsRoute
  '/doctors/$doctorId/profile': typeof AuthenticatedDoctorsDoctorIdProfileRoute
  '/doctors/$doctorId/schedule': typeof AuthenticatedDoctorsDoctorIdScheduleRoute
  '/doctors/$doctorId/signature': typeof AuthenticatedDoctorsDoctorIdSignatureRoute
  '/doctors/$doctorId': typeof AuthenticatedDoctorsDoctorIdIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/doctors/me': typeof AuthenticatedDoctorsMeRoute
  '/medical/$appointmentId': typeof AuthenticatedMedicalAppointmentIdRoute
  '/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/appointments': typeof AuthenticatedAppointmentsIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/doctors/$doctorId/documents': typeof AuthenticatedDoctorsDoctorIdDocumentsRoute
  '/doctors/$doctorId/profile': typeof AuthenticatedDoctorsDoctorIdProfileRoute
  '/doctors/$doctorId/schedule': typeof AuthenticatedDoctorsDoctorIdScheduleRoute
  '/doctors/$doctorId/signature': typeof AuthenticatedDoctorsDoctorIdSignatureRoute
  '/doctors/$doctorId': typeof AuthenticatedDoctorsDoctorIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/doctors/me': typeof AuthenticatedDoctorsMeRoute
  '/_authenticated/medical/$appointmentId': typeof AuthenticatedMedicalAppointmentIdRoute
  '/_authenticated/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/appointments/': typeof AuthenticatedAppointmentsIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/doctors/$doctorId/documents': typeof AuthenticatedDoctorsDoctorIdDocumentsRoute
  '/_authenticated/doctors/$doctorId/profile': typeof AuthenticatedDoctorsDoctorIdProfileRoute
  '/_authenticated/doctors/$doctorId/schedule': typeof AuthenticatedDoctorsDoctorIdScheduleRoute
  '/_authenticated/doctors/$doctorId/signature': typeof AuthenticatedDoctorsDoctorIdSignatureRoute
  '/_authenticated/doctors/$doctorId/': typeof AuthenticatedDoctorsDoctorIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/settings'
    | '/forgot-password'
    | '/otp'
    | '/reset-password'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/doctors/me'
    | '/medical/$appointmentId'
    | '/patients/$patientId'
    | '/settings/account'
    | '/settings/notifications'
    | '/appointments'
    | '/chats'
    | '/settings/'
    | '/tasks'
    | '/doctors/$doctorId/documents'
    | '/doctors/$doctorId/profile'
    | '/doctors/$doctorId/schedule'
    | '/doctors/$doctorId/signature'
    | '/doctors/$doctorId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/otp'
    | '/reset-password'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/doctors/me'
    | '/medical/$appointmentId'
    | '/patients/$patientId'
    | '/settings/account'
    | '/settings/notifications'
    | '/appointments'
    | '/chats'
    | '/settings'
    | '/tasks'
    | '/doctors/$doctorId/documents'
    | '/doctors/$doctorId/profile'
    | '/doctors/$doctorId/schedule'
    | '/doctors/$doctorId/signature'
    | '/doctors/$doctorId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/settings'
    | '/(auth)/forgot-password'
    | '/(auth)/otp'
    | '/(auth)/reset-password'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/doctors/me'
    | '/_authenticated/medical/$appointmentId'
    | '/_authenticated/patients/$patientId'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/appointments/'
    | '/_authenticated/chats/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/doctors/$doctorId/documents'
    | '/_authenticated/doctors/$doctorId/profile'
    | '/_authenticated/doctors/$doctorId/schedule'
    | '/_authenticated/doctors/$doctorId/signature'
    | '/_authenticated/doctors/$doctorId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authOtpRoute: typeof authOtpRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSignInRoute: typeof authSignInRoute
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/appointments/': {
      id: '/_authenticated/appointments/'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof AuthenticatedAppointmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/patients/$patientId': {
      id: '/_authenticated/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof AuthenticatedPatientsPatientIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/medical/$appointmentId': {
      id: '/_authenticated/medical/$appointmentId'
      path: '/medical/$appointmentId'
      fullPath: '/medical/$appointmentId'
      preLoaderRoute: typeof AuthenticatedMedicalAppointmentIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/doctors/me': {
      id: '/_authenticated/doctors/me'
      path: '/doctors/me'
      fullPath: '/doctors/me'
      preLoaderRoute: typeof AuthenticatedDoctorsMeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/doctors/$doctorId/': {
      id: '/_authenticated/doctors/$doctorId/'
      path: '/doctors/$doctorId'
      fullPath: '/doctors/$doctorId'
      preLoaderRoute: typeof AuthenticatedDoctorsDoctorIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/doctors/$doctorId/signature': {
      id: '/_authenticated/doctors/$doctorId/signature'
      path: '/doctors/$doctorId/signature'
      fullPath: '/doctors/$doctorId/signature'
      preLoaderRoute: typeof AuthenticatedDoctorsDoctorIdSignatureRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/doctors/$doctorId/schedule': {
      id: '/_authenticated/doctors/$doctorId/schedule'
      path: '/doctors/$doctorId/schedule'
      fullPath: '/doctors/$doctorId/schedule'
      preLoaderRoute: typeof AuthenticatedDoctorsDoctorIdScheduleRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/doctors/$doctorId/profile': {
      id: '/_authenticated/doctors/$doctorId/profile'
      path: '/doctors/$doctorId/profile'
      fullPath: '/doctors/$doctorId/profile'
      preLoaderRoute: typeof AuthenticatedDoctorsDoctorIdProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/doctors/$doctorId/documents': {
      id: '/_authenticated/doctors/$doctorId/documents'
      path: '/doctors/$doctorId/documents'
      fullPath: '/doctors/$doctorId/documents'
      preLoaderRoute: typeof AuthenticatedDoctorsDoctorIdDocumentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedDoctorsMeRoute: typeof AuthenticatedDoctorsMeRoute
  AuthenticatedMedicalAppointmentIdRoute: typeof AuthenticatedMedicalAppointmentIdRoute
  AuthenticatedPatientsPatientIdRoute: typeof AuthenticatedPatientsPatientIdRoute
  AuthenticatedAppointmentsIndexRoute: typeof AuthenticatedAppointmentsIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedDoctorsDoctorIdDocumentsRoute: typeof AuthenticatedDoctorsDoctorIdDocumentsRoute
  AuthenticatedDoctorsDoctorIdProfileRoute: typeof AuthenticatedDoctorsDoctorIdProfileRoute
  AuthenticatedDoctorsDoctorIdScheduleRoute: typeof AuthenticatedDoctorsDoctorIdScheduleRoute
  AuthenticatedDoctorsDoctorIdSignatureRoute: typeof AuthenticatedDoctorsDoctorIdSignatureRoute
  AuthenticatedDoctorsDoctorIdIndexRoute: typeof AuthenticatedDoctorsDoctorIdIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedDoctorsMeRoute: AuthenticatedDoctorsMeRoute,
  AuthenticatedMedicalAppointmentIdRoute:
    AuthenticatedMedicalAppointmentIdRoute,
  AuthenticatedPatientsPatientIdRoute: AuthenticatedPatientsPatientIdRoute,
  AuthenticatedAppointmentsIndexRoute: AuthenticatedAppointmentsIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedDoctorsDoctorIdDocumentsRoute:
    AuthenticatedDoctorsDoctorIdDocumentsRoute,
  AuthenticatedDoctorsDoctorIdProfileRoute:
    AuthenticatedDoctorsDoctorIdProfileRoute,
  AuthenticatedDoctorsDoctorIdScheduleRoute:
    AuthenticatedDoctorsDoctorIdScheduleRoute,
  AuthenticatedDoctorsDoctorIdSignatureRoute:
    AuthenticatedDoctorsDoctorIdSignatureRoute,
  AuthenticatedDoctorsDoctorIdIndexRoute:
    AuthenticatedDoctorsDoctorIdIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authOtpRoute: authOtpRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSignInRoute: authSignInRoute,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
